var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnReserveBed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.3816 8.52635C6.1182 7.78904 7.312 7.78945 8.04805 8.52725L8.94815 9.42947C9.6843 10.1673 9.6839 11.3633 8.94725 12.1006L8.76305 12.285L8.94625 12.4698C8.9751 12.4989 9.01425 12.5152 9.055 12.5152H19.5331C20.6194 12.5152 21.5 13.4048 21.5 14.5022C21.5 15.4371 20.8609 16.2212 20 16.4329V17.9922H22V18.994H18.7525C19.0767 19.3123 19.2778 19.7558 19.2778 20.2464C19.2778 21.2147 18.4943 21.9996 17.5278 21.9996C16.5613 21.9996 15.7778 21.2147 15.7778 20.2464C15.7778 19.7558 15.9789 19.3123 16.303 18.994H7.69697C8.02112 19.3123 8.22222 19.7558 8.22222 20.2464C8.22222 21.2147 7.43872 21.9996 6.47222 21.9996C5.50572 21.9996 4.72222 21.2147 4.72222 20.2464C4.72222 19.7558 4.92334 19.3123 5.24748 18.994H2V17.9922H3.5V12.6537L3.08352 12.2336C2.30549 11.4489 2.30549 10.1753 3.08352 9.3905C3.61077 8.85872 4.35994 8.6881 5.02955 8.87876L5.3816 8.52635ZM8.24045 11.3919L8.05835 11.5742L5.91315 9.41049L6.0884 9.23506C6.43435 8.88877 6.9951 8.88897 7.3408 9.23552L8.2409 10.1377C8.58655 10.4842 8.58635 11.0457 8.24045 11.3919ZM4.5 17.9922H19V16.4893H7.5361C7.38665 16.4893 7.24335 16.4293 7.1376 16.3227L4.5 13.6623V17.9922Z",
    fill: "#0B83A5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1266 5.5C18.1266 7.433 16.5178 9 14.5333 9C12.5487 9 10.9399 7.433 10.9399 5.5C10.9399 3.567 12.5487 2 14.5333 2C16.5178 2 18.1266 3.567 18.1266 5.5Z",
    fill: "#0B83A5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4713 4L14.5 4.97125L13.5287 4L13 4.52875L13.9713 5.5L13 6.47125L13.5287 7L14.5 6.02875L15.4713 7L16 6.47125L15.0287 5.5L16 4.52875L15.4713 4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnReserveBed);
export default __webpack_public_path__ + "static/media/UnReserveBed.68a6f808cccb036711c565d84e509f5d.svg";
export { ForwardRef as ReactComponent };